import { noCase } from 'change-case';
import identity from 'lodash/identity.js';
import pickBy from 'lodash/pickBy.js';

import moment from '@/plugins/vue-moment.js';
import store from '@/store/Index.js';

export const promiseError = ({ context, key }) => {
    return () => {
        context.commit('TOGGLE_LOADING');

        const plain = noCase(key.replace('_load_error', ''));

        context.dispatch('throwError', {
            key,
            message: `An error has occurred while trying to load the ${plain}. Please try again in a few minutes.`,
        });
    };
};

/**
 * Display a time from now that has been adjusted to the institution timezone.
 * @param date
 * @returns {string}
 */
export function shortDate(date) {
    return moment.utc(date).fromNow();
}

/**
 * Display a full timestamp that has been adjusted to the institution timezone.
 * @param date
 * @param timezone
 * @returns {string}
 */
export function longDate(date, timezone) {
    return moment.utc(date).tz(timezone.name).format('MMMM Do, YYYY h:mm:ss a zz');
}

export function toggleLoading(context) {
    const resolvedContext = context || store;

    resolvedContext.commit('TOGGLE_LOADING');
}

/**
 * @param context
 * @param paginate
 * @returns {Promise<any>}
 */
export async function paginateAndFetch(context, paginate) {
    await context.dispatch('updatePageParams', paginate);
    await context.dispatch('purge');
    await context.dispatch('fetch');
}

export function clearSort({ commit }) {
    commit('CLEAR_SORTING');
}

export function CLEAR_SORTING(state) {
    Object.keys(state.sort).forEach(key => (state.sort[key] = null));
}

export function pagination(state) {
    return {
        page: state.pagination.page,
        per_page: state.pagination.perPage,
    };
}

export function queryBuilderSorting(state) {
    const sorts = pickBy(state.sort, identity);

    return Object.keys(sorts).map(key => {
        return sorts[key].toLowerCase() === 'desc' ? `-${key}` : key;
    });
}
